// @flow
import { boolean, string } from 'yup';
import {
  TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES,
  TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES,
} from '@streaming-projects/orgs/enums';
import { convertConfigArrayToMap, createFormNameToFieldsMap } from '@src/configuration/utils';
import { clusterMonthlyDataInputTransformationFunc } from '@components/cluster/cluster-input-table/utils';
import { CHECKBOX_INPUT_TYPE, TEXT_NUMBER_INPUT_TYPE } from '@src/formik-utils/consts';
import { FORM_NAMES } from '@streaming-projects/enums';
import { infiniteRetentionInputValidationFunc } from '@streaming-projects/utils';

export const TABLEFLOW_WORKLOAD_DETAILS_CONFIG = [
  {
    displayName: TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME,
    backendFieldName: TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME,
    validation: string().label(TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME).required(),
    belongingForm: FORM_NAMES.TABLE_FLOW.WORKLOAD_DETAILS_FORM,
  },
  {
    displayName: TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.CLUSTER_RETENTION,
    backendFieldName: TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.CLUSTER_RETENTION,
    icon: null,
    validation: infiniteRetentionInputValidationFunc,
    inputType: TEXT_NUMBER_INPUT_TYPE,
    belongingForm: FORM_NAMES.TABLE_FLOW.WORKLOAD_DETAILS_FORM,
  },
  {
    displayName: TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.CLUSTER_RETENTION_INFINITE,
    backendFieldName: TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.CLUSTER_RETENTION_INFINITE,
    icon: null,
    inputType: CHECKBOX_INPUT_TYPE,
    belongingForm: FORM_NAMES.TABLE_FLOW.WORKLOAD_DETAILS_FORM,
  },
  {
    displayName: TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED,
    backendFieldName: TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED,
    validation: boolean().label(TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED).required(),
  },
  {
    displayName: TABLEFLOW_WORKLOADS_INPUTS_DISPLAY_NAMES.MONTHLY_INPUTS,
    backendFieldName: TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.MONTHLY_INPUTS,
    inputTransformationFunc: clusterMonthlyDataInputTransformationFunc,
    belongingForm: FORM_NAMES.TABLE_FLOW.WORKLOAD_MONTHLY_USAGE_FORM,
  },
];

export const TABLEFLOW_WORKLOAD_DETAILS_CONFIG_MAP = convertConfigArrayToMap(
  TABLEFLOW_WORKLOAD_DETAILS_CONFIG
);

export const TABLEFLOW_WORKLOAD_DETAILS_FORM_NAMES_TO_FIELDS_MAP = createFormNameToFieldsMap(
  TABLEFLOW_WORKLOAD_DETAILS_CONFIG
);
